import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * New routes should open already at the top — no animated scroll-up.
 * SPA navigations otherwise keep the previous window / document offset.
 */
export function scrollDocumentToTop() {
  if (typeof window === 'undefined') return;
  try {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  } catch {
    // ignore
  }

  const html = document.documentElement;
  const body = document.body;
  const prevHtml = html?.style?.scrollBehavior;
  const prevBody = body?.style?.scrollBehavior;
  if (html) html.style.scrollBehavior = 'auto';
  if (body) body.style.scrollBehavior = 'auto';

  try {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  } catch {
    window.scrollTo(0, 0);
  }
  if (html) html.scrollTop = 0;
  if (body) body.scrollTop = 0;

  if (html) html.style.scrollBehavior = prevHtml || '';
  if (body) body.style.scrollBehavior = prevBody || '';
}

export function ScrollToTopOnNavigate() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    scrollDocumentToTop();
  }, [pathname]);

  return null;
}
